import React from 'react';
import { XIcon, MessageSquareIcon } from 'lucide-react';
interface TemplatePickerModalProps {
  onClose: () => void;
  onSelect: (template: string) => void;
}
export function TemplatePickerModal({
  onClose,
  onSelect
}: TemplatePickerModalProps) {
  const templates = [{
    id: '1',
    name: 'Welcome Message',
    text: "Hi! Welcome to your personalized nutrition journey. I'm excited to work with you. Let's start by discussing your health goals."
  }, {
    id: '2',
    name: 'Weekly Check-in',
    text: "Hi! Hope you're doing well. How has this week been with the meal plan? Any challenges or questions?"
  }, {
    id: '3',
    name: 'Grocery List Reminder',
    text: "Don't forget to check your grocery list for this week! I've included all the items you'll need for your meal plan."
  }, {
    id: '4',
    name: 'Meal Plan Update',
    text: "I've updated your meal plan based on our last conversation. Please review it and let me know if you have any questions."
  }, {
    id: '5',
    name: 'Appointment Reminder',
    text: 'Reminder: We have our follow-up consultation scheduled for tomorrow. Looking forward to hearing about your progress!'
  }];
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end sm:items-center justify-center p-4">
      <div className="bg-white rounded-t-3xl sm:rounded-3xl w-full max-w-lg max-h-[80vh] overflow-hidden flex flex-col animate-slide-up">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-[#212121]">
            Select Template
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors">
            <XIcon className="w-6 h-6" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {templates.map(template => <button key={template.id} onClick={() => onSelect(template.text)} className="w-full text-left p-4 bg-gray-50 hover:bg-gray-100 rounded-xl transition-colors">
              <div className="flex items-start gap-3">
                <MessageSquareIcon className="w-5 h-5 text-[#5B8E87] flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-sm text-[#212121] mb-1">
                    {template.name}
                  </h3>
                  <p className="text-xs text-gray-600 line-clamp-2">
                    {template.text}
                  </p>
                </div>
              </div>
            </button>)}
        </div>
      </div>
    </div>;
}